// The developer's letter — shown once on a device's first launch
// (welcome card over the loader, with 'click to begin' beneath) and
// available any time after via the 'about' link in the bottom-left
// corner. Text lowercased to match the game's voice.

export const ABOUT_GREETING = 'hey guys, angryjuniper here!';

export const ABOUT_PARAGRAPHS: string[] = [
  'thank you for checking out this project, especially while it is in its earliest and roughest stages. settle doesn’t attempt to be the best version of tetris ever made, or even the most polished. i started this project because i simply wanted a simple, relaxing tetris-like that i truly enjoy playing.',
  'part of what prompted me to start creating settle was simple nostalgia too. my brother and i spent hour after hour playing on a now-defunct website called tetris friends when we were kids, and while it had competitive modes and the traditional anxiety-inducing, fast paced theme song, it also had customization options, more relaxing songs, and a variety of modes. over the years, i have never found a substitute that fully brought me the same enjoyment.',
  'i truly hope you enjoy playing and exploring this game as much as i do, even while it is still taking shape. i appreciate any feedback you’re willing to offer as you play, but most of all, try and have some fun!',
];

export const ABOUT_SIGNOFF = '— angryjuniper';

/** Device-global flag — '1' once the first-visit welcome has been
 *  dismissed on this browser. Deliberately NOT per-profile: the
 *  welcome is a per-device hello, not a per-save state. */
export const WELCOME_SEEN_KEY = 'settle:welcome-seen';
